import {
  showBoclipsSearch,
  showDatabaseSearch,
  showProQuestSearch,
} from "config";
import {
  getSearchCredentialSettings,
  isSearchProviderEnabled,
  SEARCH_PROVIDER_TYPES,
} from "utils/search-credentials-settings.util";

const baseSources = [
  { label: "By Categories", key: "categories", default: true },
  { label: "By Media Bias", key: "rating" },
  { label: "Peer Reviewed", key: "peer-reviewed" },
  { label: "Partner Publishers", key: "partner-publishers" },
  { label: "Books", key: "books" },
  { label: "Encyclopedia & Dictionary", key: "wiki" },
];

export const sources = showDatabaseSearch
  ? [
      ...baseSources.slice(0, 2),
      { label: "Databases", key: "databases" },
      ...baseSources.slice(2),
    ]
  : baseSources;

export const databaseDisabledMessage =
  "Your account has not activated any database integration.";

export const getSources = (settings = getSearchCredentialSettings()) =>
  sources.map((source) =>
    source.key === "databases" &&
    !databaseCategories.some((category) =>
      isSearchProviderEnabled(category.credentialType, settings)
    )
      ? {
          ...source,
          disabled: true,
          disabledReason: databaseDisabledMessage,
        }
      : source
  );

export const boClipsLabel = "Videos";

export const ebscoLabel = "EBSCO";
export const proQuestLabel = "ProQuest";

const allDatabaseCategories = [
  {
    label: ebscoLabel,
    key: "ebsco",
    credentialType: SEARCH_PROVIDER_TYPES.ebsco,
  },
  {
    label: proQuestLabel,
    key: "proquest",
    credentialType: SEARCH_PROVIDER_TYPES.proQuest,
  },
];

// Filtering here keeps every consumer consistent: the Databases chips in the
// search menu, the "no integration activated" check in getSources, and the
// label lookups used when building or parsing a database search URL.
export const databaseCategories = allDatabaseCategories.filter(
  (category) => category.key !== "proquest" || showProQuestSearch
);

export const getDatabaseCategories = (settings = getSearchCredentialSettings()) =>
  databaseCategories.map((category) => {
    const enabled = isSearchProviderEnabled(category.credentialType, settings);
    return enabled
      ? category
      : {
          ...category,
          disabled: true,
          disabledReason: `${category.label} is not configured or is currently disabled for your group.`,
        };
  });

const baseCategories = [
  { label: "Global News", key: "global-news" },
  { label: "Periodicals & Specialty News", key: "periodics" },
  { label: "Think Tanks", key: "think-tanks" },
  { label: "Academia & Scholarly Resources", key: "academia" },
  { label: "Other Selected Sources", key: "others" },
  { label: "US Government", key: "us-government" },
  { label: "Intergovernmental Organizations", key: "intergovernment" },
];

export const getCategories = (isHomeschool = false) => {
  const categories = [...baseCategories];
  if (showBoclipsSearch || isHomeschool) {
    categories.push({ label: boClipsLabel, key: "boclips" });
  }
  return categories;
};

export const categories = getCategories();

export const academicSources = [
  { label: "CORE", key: "1" },
  { label: "Semantic Scholar", key: "2" },
  { label: "Arxiv", key: "3" },
  { label: "Springer Nature", key: "4" },
  { label: "PLOS", key: "5" },
];

export const publishersArray = [
  { label: "The Christian Science Monitor", key: "The Christian Science Monitor" },
  { label: "Financial News",                key: "Financial News" },
  { label: "Business Insider",                key: "Business Insider" },
  // { label: "The Economist",                 key: "The Economist" },
  { label: "Foreign Policy",                key: "Foreign Policy" },
  { label: "MIT Technology Review",         key: "MIT Technology Review" },
  { label: "The Nation",                    key: "The Nation" },
  { label: "The New Republic",              key: "The New Republic" },
  { label: "Project Syndicate",             key: "Project Syndicate" },
  { label: "The Washington Post",           key: "The Washington Post" },
  { label: "The Washington Times",          key: "The Washington Times" },
];

export const biasCategories = [
  { label: "Left & Lean Left", key: "Left" },
  { label: "Center", key: "Center" },
  { label: "Right & Lean Right", key: "Right" },
];

export const frequencies = [
  { label: "Past 24 hours", key: "past-day" },
  { label: "Past Week", key: "past-week" },
  { label: "Past Month", key: "past-month" },
  { label: "Past Year", key: "past-year" },
  { label: "Past 2 Years", key: "past-two-years" },
  { label: "Past 3 Years", key: "past-three-years" },
  { label: "All time", key: "all-time", default: true },
  { label: "Custom Date", key: "custom-date" },
];
